import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useD103Form } from './hooks/useD103Form';

const D103Form: React.FC = () => {
  const {
    mode, isEditing, loading,
    records, current, currentIdx,
    fields, setField,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save,
    doDelete, quickSearch,
  } = useD103Form();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除「${current.fd03_01}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => {
    if (searchText.trim()) quickSearch(searchText.trim());
  };

  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-3xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          託工類別建檔 (pwd103f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        {/* Quick Search */}
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="輸入類別代號查詢" value={searchText}
            onChange={e => setSearchText(e.target.value)} onPressEnter={handleQuickSearch}
            disabled={isEditing} style={{ width: 200 }} maxLength={8} />
          <Button onClick={handleQuickSearch} disabled={isEditing}>查詢</Button>
        </div>

        {/* Navigation */}
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || records.length === 0}>&gt;|</Button>
        </div>

        {/* Form Fields */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-3 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">類別代號</label>
            <Input value={fields.fd03_01} onChange={e => setField('fd03_01', e.target.value)}
              maxLength={8} disabled={mode !== 'add'} style={{ width: 200 }} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">加工類別</label>
            <Input value={fields.fd03_02} onChange={e => setField('fd03_02', e.target.value)}
              maxLength={8} disabled={!isEditing} style={{ width: 200 }} />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">類別名稱</label>
            <Input value={fields.fd03_11} onChange={e => setField('fd03_11', e.target.value)}
              maxLength={30} disabled={!isEditing} style={{ width: '100%' }} />
          </div>
        </div>

        {/* Audit Fields */}
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-4 space-y-1">
            <div>建立者: {current.fd03_91} | 建立日期: {current.fd03_92 || '-'}</div>
            <div>更新者: {current.fd03_93}</div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default D103Form;
